module.exports = __webpack_public_path__ + "static/media/flag-united-kingdom.53ce0769.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/LanguageFlag/LanguageFlagIcons/flag-united-kingdom.svg
// module id = 1137
// module chunks = 1